<script>
import { mapGetters } from 'vuex'
import TabBase from './tabs/Base'
import TabCompanies from './tabs/Companies'
import Roles from '@/mixins/Roles'
export default {
    name: 'AddressView',

    components: { TabBase, TabCompanies },

    mixins: [Roles],

    computed: mapGetters({ address: 'address' }),

    watch: {
        $route: 'fetch',
    },

    mounted() {
        this.fetch()
    },

    methods: {
        fetch() {
            this.$store.dispatch('addressFetch', this.$route.params.address)
        },
    },
}
</script>

<template lang="pug">
div(v-if="address && address.id")
    acrm-tabs(:key="`address-${address.id}`")
        acrm-tab(:name="$t('BASE.BASEDATA')" tabKey="base-data" v-if="hasRoleView('address.fields.address')")
            tab-base

        acrm-tab(:name="$t('COMPANIES.COMPANIES')" tabKey="companies" v-if="hasRoleView('address.fields.companies')")
            tab-companies

</template>
